import { render, staticRenderFns } from "./ConfiguracaoCadastro.vue?vue&type=template&id=61d509c8&lang=html&"
import script from "./ConfiguracaoCadastro.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoCadastro.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoCadastro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/configuracao/ConfiguracaoCadastro.vue
// module id = 1162
// module chunks = 28